// ** MUI
import Box from '@mui/material/Box';

// ** Components
import HorizontalNavListItems from './HorizontalNavListItems';
import type { LayoutProps } from '../../../../types';

// ** Config
import themeConfig from '../../../../config';

interface Props {
  settings: LayoutProps['settings'];
  horizontalNavItems: NonNullable<
    NonNullable<LayoutProps['horizontalLayoutProps']>['navMenu']
  >['navItems'];
}

const Navigation = (props: Props) => {
  return (
    <Box
      className="menu-content"
      sx={{
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        '& > *': {
          '&:not(:last-child)': { mr: 2 },
          ...(themeConfig.config.menuTextTruncate && { maxWidth: 220 }),
        },
      }}
    >
      <HorizontalNavListItems {...props} />
    </Box>
  );
};

export default Navigation;
